import { fromEvent, merge } from 'rxjs'
import { mapTo, debounceTime } from 'rxjs/operators'

import $ from 'jquery'
import 'slick-carousel'

export default class AboutController {
  constructor (element) {
    this._element = element
    this._initSlick()
    this._initChronologyListeners()
  }

  _initSlick () {
    const $slickElement = $(this._element).find('.about__photos__slider')
    this._$slickElement = $slickElement
    $slickElement.slick({
      slidesToShow: 1,
      // speed: 10000,
      // autoplay: true,
      // autoplaySpeed: 0,
      // pauseOnFocus: false,
      // pauseOnHover: false,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 3000,
      speed: 500,
      fade: true,
      swipe: false,
      mobileFirst: true,
      prevArrow: null, // '.' + previousButtonClass,
      nextArrow: null // '.' + nextButtonClass,
    })
  }

  _initChronologyListeners () {
    const chronologyWrapper = this._element.querySelector('.about__text__chronology')

    if (chronologyWrapper) {
      const observables = []
      observables.push(
        fromEvent(chronologyWrapper, 'mouseleave')
          .pipe(mapTo(0))
      )

      const chronologyItems = chronologyWrapper.querySelectorAll('[data-chronology-image-index]')
      ;[].forEach.call(chronologyItems, element => {
        const imageIndexAttr = element.getAttribute('data-chronology-image-index')
        if (imageIndexAttr) {
          const imageIndex = parseInt(imageIndexAttr)
          observables.push(
            fromEvent(element, 'mouseenter')
              .pipe(mapTo(imageIndex))
          )
        }
      })

      merge(...observables)
        .pipe(debounceTime(50))
        .subscribe(index => {
          this._showImageByIndex(index)
        })
    }
  }

  _showImageByIndex (index) {
    this._$slickElement.slick('slickGoTo', index)
  }
}
